// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emphelpdeskpage-inline-1 {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #2563eb;
  margin-bottom: 12px;
}

.emphelpdeskpage-inline-2 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.emphelpdeskpage-inline-3 {
  padding: 0;
}

.emphelpdeskpage-inline-4 {
  font-family: monospace;
  font-size: 11px;
}

.emphelpdeskpage-inline-5 {
  font-weight: 600;
}

.emphelpdeskpage-inline-6 {
  color: #94a3b8;
}

.emphelpdeskpage-inline-7 {
  font-size: 11px;
  max-width: 180px;
}

.emphelpdeskpage-inline-8 {
  color: #2563eb;
  font-weight: 600;
}

.emphelpdeskpage-inline-9 {
  color: #94a3b8;
}

.emphelpdeskpage-dyn-1 {
  font-size: 11px;
  font-weight: 600;
  color: var(--emphelpdeskpage-1-color);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpHelpDeskPage.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC","sourcesContent":[".emphelpdeskpage-inline-1 {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 10px;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2563eb;\n  margin-bottom: 12px;\n}\n\n.emphelpdeskpage-inline-2 {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.emphelpdeskpage-inline-3 {\n  padding: 0;\n}\n\n.emphelpdeskpage-inline-4 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.emphelpdeskpage-inline-5 {\n  font-weight: 600;\n}\n\n.emphelpdeskpage-inline-6 {\n  color: #94a3b8;\n}\n\n.emphelpdeskpage-inline-7 {\n  font-size: 11px;\n  max-width: 180px;\n}\n\n.emphelpdeskpage-inline-8 {\n  color: #2563eb;\n  font-weight: 600;\n}\n\n.emphelpdeskpage-inline-9 {\n  color: #94a3b8;\n}\n\n.emphelpdeskpage-dyn-1 {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--emphelpdeskpage-1-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
